import {
  ROLE_ADMIN,
  ROLE_PROJECT_RADAR,
  ROLE_COLLABORATOR_ADMIN,
  ROLE_COLLABORATOR_VIEWER,
  ROLE_COLLABORATOR_EDITOR,
  ROLE_SALARY_ADMIN,
  ROLE_SALARY_VIEW,
  ROLE_CALCULATOR,
  ROLE_EVALUATION_ADMIN,
  ROLE_VACATION_DP,
  ROLE_VACATION_VIEWER,
  ROLE_SI_ADMIN,
  ROLE_SI_RH,
  ROLE_RECRUITMENT_ADMIN,
} from "@/contexts/AuthContext";

// Combinações de roles comuns
export const ROLE_COMBINATIONS = {
  ALL_ROLES: [
    ROLE_ADMIN,
    ROLE_PROJECT_RADAR,
    ROLE_COLLABORATOR_ADMIN,
    ROLE_COLLABORATOR_VIEWER,
    ROLE_EVALUATION_ADMIN,
  ],
  ADMIN_ONLY: [ROLE_ADMIN],
  ADMIN_AND_PROJECT: [ROLE_ADMIN, ROLE_PROJECT_RADAR],
  CALCULATOR_FULL: [ROLE_ADMIN, ROLE_CALCULATOR, ROLE_COLLABORATOR_ADMIN],
  CALCULATOR_BASIC: [ROLE_ADMIN, ROLE_CALCULATOR],
  COLLABORATOR_MANAGEMENT: [ROLE_ADMIN, ROLE_COLLABORATOR_ADMIN, ROLE_COLLABORATOR_EDITOR],
  COLLABORATOR_EDIT_PAGE: [ROLE_ADMIN, ROLE_COLLABORATOR_ADMIN, ROLE_COLLABORATOR_EDITOR, ROLE_VACATION_DP],
  COLLABORATOR_ACCESS: [
    ROLE_ADMIN,
    ROLE_COLLABORATOR_ADMIN,
    ROLE_COLLABORATOR_VIEWER,
    ROLE_COLLABORATOR_EDITOR,
  ],
  EVALUATION_ACCESS: [ROLE_ADMIN, ROLE_EVALUATION_ADMIN],
  PEOPLE_ACCESS: [
    ROLE_ADMIN,
    ROLE_COLLABORATOR_ADMIN,
    ROLE_COLLABORATOR_VIEWER,
    ROLE_COLLABORATOR_EDITOR,
    ROLE_EVALUATION_ADMIN,
  ],
  VACATION_DP: [ROLE_ADMIN, ROLE_VACATION_DP],
  VACATION_OVERVIEW: [ROLE_ADMIN, ROLE_VACATION_DP, ROLE_VACATION_VIEWER],
  // Módulo SI: qualquer usuário autenticado pode acessar (abrir/ver as próprias
  // solicitações) — a autorização granular de execução/administração é feita por
  // role dentro das telas e reforçada em firestore.rules (Discovery §10.4).
  SI_ACCESS: [] as string[],
  SI_ADMIN_ONLY: [ROLE_SI_ADMIN],
  // Qualquer role cadastrada no Digital (usado onde o acesso deve ser liberado a
  // todo colaborador com alguma permissão, mas negado a quem está logado sem
  // nenhuma role atribuída) — diferente de SI_ACCESS ([]), que libera até quem
  // não tem role nenhuma.
  ANY_ROLE: [
    ROLE_ADMIN,
    ROLE_PROJECT_RADAR,
    ROLE_COLLABORATOR_ADMIN,
    ROLE_COLLABORATOR_VIEWER,
    ROLE_COLLABORATOR_EDITOR,
    ROLE_SALARY_ADMIN,
    ROLE_SALARY_VIEW,
    ROLE_CALCULATOR,
    ROLE_EVALUATION_ADMIN,
    ROLE_VACATION_DP,
    ROLE_VACATION_VIEWER,
    ROLE_SI_ADMIN,
    ROLE_SI_RH,
    ROLE_RECRUITMENT_ADMIN,
  ],
};

// Layouts disponíveis
export const LAYOUTS = {
  DEFAULT: "default",
  AUTH: "auth",
  NONE: "none",
} as const;
